import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import CustomPage from "@/pages/CustomPage";
import MenuPage from "@/pages/MenuPage";
import ChefPage from "@/pages/ChefPage";
import ReservationPage from "@/pages/ReservationPage";
import ContactPage from "@/pages/ContactPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/chef" element={<ChefPage />} />
          <Route path="/rezervo" element={<ReservationPage />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/p/:slug" element={<CustomPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
